export default __webpack_public_path__ + "static/media/FireUp-black-removebg.6770b74f.png";